import React, { Component } from "react";
//import React, { useState, useEffect } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import Table from "../../components/Table/Table.jsx";
import Card from "../../components/Card/Card.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
import Button from "../../components/CustomButtons/Button.jsx";
import { withApollo } from "react-apollo";
import { flowRight } from "lodash";

import gql from "graphql-tag";
import Context from "../../data/context";
import { spinnerService } from "@chevtek/react-spinners";
import OpenSelect from "./OpenSelect";
import { connect } from "react-redux";
import Pagination from "../../components/pagination/pagination";
import * as actionTypes from "../../redux/actions";
import { LIST_INSPECTION, getVehicles } from "../../config/myqueries";
var allInspections = [];

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  }
};
class Inspections extends Component {
  static contextType = Context;
  constructor(props) {
    super(props);
  }
  state = {
    customer: {},
    inspections: [],
    uniqueVehicles: [],
    vehAdded: false,
    start: 0,
    end: 10
  };
  loadData = async (user, reload) => {
    const { client } = this.props;
    if (reload === false) {
      spinnerService.show("mySpinner");
    }

    if (user) {
      try {
        const inspectionDetails = await client.query({
          query: gql(LIST_INSPECTION),
          fetchPolicy: `network-only`,
          variables: { limit: 1000 }
        });

        if (inspectionDetails.data.listInspections) {
          this.arrangeInspection(
            inspectionDetails.data.listInspections.items,
            user
          );
        } //end of listInspecitons
      } catch (err) {}
    } // end if(user)

    if (reload === false) {
      spinnerService.hide("mySpinner");
    }
  };

  arrangeInspection = (inspectionDetails, user) => {
    var selectInsp = [];
    inspectionDetails.map(Item => {
      if (Item.vehicle != null) {
        if (Item.vehicle.customer != null) {
          if (Item.vehicle.customer.id === user.username) {
            var obj = {
              objId: Item.id,
              customerVehicleId: Item.vehicle.customerVehicleId
            };
            if (!selectInsp.includes(obj)) {
              selectInsp.push(obj);
            }
          }
        }
      }
    });
    var o = inspectionDetails.filter(function(obj) {
      if (obj.vehicle != null && obj.vehicle.customer != null) {
        if (obj.vehicle.customer.id === user.username) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    });
    o.sort(function(a, b) {
      return new Date(b.startAt) - new Date(a.startAt);
    });
    var inspections = { inspections: o, uniqueVehicles: selectInsp };
    this.props.storeInspection(inspections);
    allInspections = o;
    this.setState({
      inspections: o,
      uniqueVehicles: selectInsp
    });
  };
  async componentDidMount() {
    const { user, client } = this.props;

    if (this.props.data === undefined || this.props.data.length == 0) {
      await this.loadData(user, false);
    } else {
      this.setState({
        inspections: this.props.data.inspections
        // uniqueVehicles: this.props.data.uniqueVehicles
      });
      await this.loadData(user, true);
    }

    client
      .query({
        query: gql(getVehicles)
      })
      .then(data => {
        this.setState({
          uniqueVehicles: data.data.listVehicles.items
        });
      })
      .catch(err => {});
  }
  selectedVehicle = id => {
    if (id === "All") {
      this.setState({ inspections: allInspections });
    } else {
      var o = allInspections.filter(function(obj) {
        return obj.vehicle.id === id;
      });
      this.setState({ inspections: o });
    }
  };
  changePage = i => {
    let start = i * 10 - 10,
      end = i * 10;
    this.setState({ start, end });
  };
  render() {
    const { classes, client, user } = this.props;
    const { inspections, uniqueVehicles, start, end } = this.state;
    return (
      <React.Fragment>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <div style={{ float: "right", padding: "15px" }}>
              <Button
                color="secondary"
                onClick={() => this.loadData(user, false)}
              >
                Refresh
              </Button>
            </div>
            <div style={{ float: "left", padding: "15px" }}>
              <OpenSelect
                selectedVehicle={this.selectedVehicle}
                uniqueVehicles={uniqueVehicles}
              />
            </div>
            <Card>
              <CardHeader color="primary">
                <h4 className={classes.cardTitleWhite}>
                  Inspections Performed
                </h4>
                <p className={classes.cardCategoryWhite}>
                  Log of inspection data for each vehicle
                </p>
              </CardHeader>
              <CardBody style={{ minHeight: 585 }}>
                {inspections.length !== 0 ? (
                  <Table
                    tableHeaderColor="primary"
                    tableHead={[
                      "Customer Veh ID",
                      "CalBit ID",
                      "Inspection Type",
                      "Inspection Date",
                      "Status",
                      "Details"
                    ]}
                    tableData={inspections.slice(start, end)}
                    inspections={true}
                    client={client}
                  />
                ) : null}
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        {inspections.length > 0 && (
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <Pagination
                onPageSelect={this.changePage}
                start={start}
                data={inspections}
              />
            </GridItem>
          </GridContainer>
        )}
      </React.Fragment>
    );
  }
}
const mapStateToProps = state => {
  return {
    user: state.config.user,
    client: state.config.client,
    loading: state.inspections.loading,
    data: state.inspections.data
  };
};
const mapDispatchToProps = dispatch => {
  return {
    storeInspection: data =>
      dispatch({ type: actionTypes.STORE_INSPECTION, data: data }),
    requestInspection: () => dispatch(actionTypes.requestInspection())
  };
};
export default Inspections = connect(
  mapStateToProps,
  mapDispatchToProps
)(flowRight(withApollo)(withStyles(styles)(Inspections)));



// WEBPACK FOOTER //
// ./src/views/Inspections/Inspections.jsx